import { render, staticRenderFns } from "./UniqueServicesSection.vue?vue&type=template&id=73136c79&scoped=true"
import script from "./UniqueServicesSection.vue?vue&type=script&lang=js"
export * from "./UniqueServicesSection.vue?vue&type=script&lang=js"
import style0 from "./UniqueServicesSection.vue?vue&type=style&index=0&id=73136c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73136c79",
  null
  
)

export default component.exports